import { getEmailSettingsApi, setEmailPrefApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

function ClientEmailNotifications() {
    const {makeApiCallFunc, userDetails} = useContext(Context);
  const [emailPref, setEmailPref] = useState(null);

  useEffect(() => {
    makeApiCallFunc(getEmailSettingsApi, null, ({data}) => {
      setEmailPref(data);
    },
    (data) => console.log(data))
  },[userDetails])


    const stopEmails = () => {
        makeApiCallFunc
        (  setEmailPrefApi, {type: 1, triggerType: 1, user: userDetails._id}, 
          ({data}) =>  {
            toast.success("You will not receive emails from us")
            setEmailPref((prev) => ({"type": 1, "triggerType": 1}))
          }, 
          (data) => console.log(data))
        
      }
      const startEmails = () => {
        makeApiCallFunc
        (  setEmailPrefApi, {type: 0, triggerType: 0, user: userDetails._id}, ({data}) => {
          toast.success("You will start receiveing emails from us")
          setEmailPref((prev) => ({"type":0, "triggerType": 0}))
          
        }
        , (data) => console.log(data))
        
      }
  return (
    <div className='w-full font-plexsans'>
      <h2 style={{margin:'0 0 22px', font:"400 22px/1.25 'Spectral',serif", color:'#14213d'}}>Email notifications</h2>
      {
        emailPref?.type === 0 ?
        <div className="rounded-sm" style={{border:'1px solid rgba(58,125,79,.3)', background:'rgba(58,125,79,.06)', padding:'22px 24px'}}>
            <div className='flex items-center gap-2 mb-2'>
              <span className="flex-none rounded-full" style={{width:'7px', height:'7px', background:'#3a7d4f'}}></span>
              <span style={{font:"500 13px/1 'IBM Plex Sans',sans-serif", color:'#14213d'}}>You're currently receiving emails</span>
            </div>
            <p style={{margin:'0 0 18px', font:"400 13.5px/1.6 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.6)'}}>We'll notify you about new attorney interest and updates on your case's progress. You can turn these off at any time.</p>
            <button
              className="cursor-pointer rounded-sm"
              style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#14213d', background:'transparent', border:'1px solid rgba(20,33,61,.25)', padding:'12px 20px'}}
              onClick={stopEmails}
              >Turn off email notifications</button>
          </div>
          :
          <div className="rounded-sm" style={{border:'1px solid rgba(20,33,61,.16)', background:'#fffdf8', padding:'22px 24px'}}>
            <div className='flex items-center gap-2 mb-2'>
              <span className="flex-none rounded-full" style={{width:'7px', height:'7px', background:'rgba(20,33,61,.35)'}}></span>
              <span style={{font:"500 13px/1 'IBM Plex Sans',sans-serif", color:'#14213d'}}>You're not receiving emails</span>
            </div>
            <p style={{margin:'0 0 18px', font:"400 13.5px/1.6 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.6)'}}>Start receiving emails from us regarding available attorneys and updates on your case progress.</p>
            <button
              className="cursor-pointer rounded-sm transition-colors"
              style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 20px'}}
              onMouseEnter={(e) => e.currentTarget.style.background = '#6d4c25'}
              onMouseLeave={(e) => e.currentTarget.style.background = '#8a6231'}
              onClick={startEmails}
              >Send me emails</button>
          </div>
        }
    </div>
  )
}

export default ClientEmailNotifications
